export type Theme = 'dark' | 'light';

/* Keep the existing 'theme' key so saved preferences and the current bootstrap
   in Layout keep working — location-intelligence uses 'pp-theme', but switching
   keys would silently reset every user to dark on first load after deploy. */
const KEY = 'theme';

export function getTheme(): Theme {
  const stored = localStorage.getItem(KEY);
  return stored === 'light' ? 'light' : 'dark';
}

export function setTheme(theme: Theme): Theme {
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem(KEY, theme);
  return theme;
}

export function toggleTheme(): Theme {
  return setTheme(getTheme() === 'dark' ? 'light' : 'dark');
}
